
import InputText from "primevue/inputtext";
import ProgressSpinner from 'primevue/progressspinner';
import Button from "primevue/button";
import { Form, Field, ErrorMessage } from "vee-validate";

import { defineComponent, onBeforeMount, onBeforeUnmount, onMounted, ref, reactive, computed, Ref } from "vue";

import { useI18n } from "vue-i18n";
import {
  IAlert,
  RouterName,
} from "@/models/common";
import { messageType } from "@/models/message";
import { getFormatedDateString } from "@/utils/date-format";

import router from '@/router';
import $API from "@/services";

export default defineComponent({
  name: "Invited Link",

  props: {
    access: String
  },

  setup(props) {

    const state = reactive({
      inviter:'',
      roomName: '',
      expireDate: '',
      access: props.access,
    });

    const { t, locale } = useI18n({ useScope: "global" });

    const participant = ref('');
    const password = ref('');
    const roomStatusText = ref('');
    const roomJoinedCount = ref(0);

    const isFetchingInfo = ref(false);
    const isFetchingJoin = ref(false);

    const alert: Ref<IAlert> = ref({
      type: messageType.ERROR,
      content: "",
    });

    const intervalId = ref(0);
    onBeforeMount(async()=>{
    })
    onBeforeUnmount(async()=>{
      console.log('onBeforeUnmount');
      clearInterval(intervalId.value );
    })

    onMounted(async()=>{
      console.log(state, 'onMounted');

      await fetchRoomUserInfo();
      await fetchLinkInfo();

      intervalId.value = setInterval(async ()=>{
        
        fetchRoomUserInfo();
        
      }, 10000);
    })

    const fetchLinkInfo = async ()=>{
      try {
        const access = props.access || '';

        isFetchingInfo.value = true;
        const linkInfo = await $API.VideoChatService.getLinkInfo(access);
        console.log(linkInfo, 'linkInfo');
        if(linkInfo) {
          state.inviter = linkInfo.Inviter;
          state.expireDate = getFormatedDateString(linkInfo.ExpireDate);
          state.roomName = linkInfo.RoomName;
        }
        
      } catch(ex) {
        console.warn(ex, '<=ex');
      } finally {
        isFetchingInfo.value = false;
      }
    }

    const fetchRoomUserInfo = async ()=>{
      try {
        const access = props.access || '';

        isFetchingInfo.value = true;
        const roomUsers = await $API.VideoChatService.getLinkRoomUsers(access);
        console.log(roomUsers, '<=roomUsers');
        if(roomUsers && roomUsers.length>0) {
          roomJoinedCount.value = roomUsers.length;
        } else {
          roomJoinedCount.value = 0;
        }
      } catch(ex) {
        console.warn(ex, '<=ex');
        roomJoinedCount.value = 0;
      } finally {
        isFetchingInfo.value = false;
      }

      roomStatusText.value = t('connected count to room', {count: roomJoinedCount.value})
    }

    // 비디오 채팅에 참가
    const joinVideoChat = async (errors:any) => {
      console.log(participant.value, '<=participant');
      console.log(password.value, '<=password');

      try {
        console.log(errors, '<=errors');

        const access = props.access || '';

        isFetchingJoin.value = true;
        const verified = await $API.VideoChatService.verifyLinkPassword(access, participant.value, password.value);
        console.log(verified, '<=verified');
        if(verified && verified.ChatUrl && verified.ChatUrl.length>0) {
          router.push({
            name: RouterName.ONLINE_CARE_VIDEO_GUEST,
            params: {
               url: verified.ChatUrl,
               id:verified.RefKey,
               guest: 'true'
            },
          });
        }  
      } catch(ex:any) {
        console.warn(ex, '<=ex');
        alert.value.content = ex.Exception;
      } finally {
        isFetchingJoin.value = false;
      }
    }
    
    const refreshRoomStatus = async () => {
      console.log('refreshRoomSratus');
    }

    // 방 상태 정보
    const roomStatus = computed(() => {
      return roomStatusText.value;
    });

    // 방에 참가 가능 여부
    const isRoomJoinable = computed(()=>{
      return roomJoinedCount.value > 0;
    });

    return {
      state,
      alert,
      t,
      locale,
      participant,
      password,
      RouterName,
      roomStatus,
      refreshRoomStatus,
      joinVideoChat,
      isRoomJoinable,
      isFetchingInfo,
      isFetchingJoin
    };
  },
  components: {
    InputText,
    Button,
    ProgressSpinner,
    Form,
    Field,
    ErrorMessage
  },
});
